import { render, staticRenderFns } from "./Complement.vue?vue&type=template&id=33044e76&scoped=true&"
import script from "./Complement.vue?vue&type=script&lang=js&"
export * from "./Complement.vue?vue&type=script&lang=js&"
import style0 from "./Complement.vue?vue&type=style&index=0&id=33044e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33044e76",
  null
  
)

export default component.exports